import React, { FunctionComponent } from "react";
import styles from "./ProductCard.module.scss";
import ProductCardContent from "./ProductCardContent.model";

import Anchor from "components/Anchor/Anchor";
import ImageViewer from "components/ImageViewer/ImageViewer";
import productUrl from "../helpers/productUrl";

const ProductCard: FunctionComponent<ProductCardContent> = (props) => {
    const image = props.productImage;

    return (
        <div className={styles.wrapper}>
            <div className={styles.inner}>
                <Anchor className={styles.media_link} to={productUrl(props.sku, props.language)}>
                    {image ? (
                        <ImageViewer className={styles.image} src={image.url} aspectRatioX={1} aspectRatioY={1} alt={props.itemName} />
                    ) : null}

                    {!image ? (
                        <div className={styles.no_image}>&otimes;</div>
                    ) : null}
                </Anchor>
                <Anchor className={styles.content_link} to={productUrl(props.sku, props.language)}>
                    {/* TODO: Tagline */}
                    {props.mainCategoryTitle ? (
                        <span className={styles.tagline}>{props.mainCategoryTitle}</span>
                    ) : null}

                    {/* Headline */}
                    {props.itemName ? (
                        <strong className={styles.headline}>{props.itemName}</strong>
                    ) : null}
                </Anchor>
            </div>
        </div>
    );
};

export default ProductCard;